import axios from 'axios'
import { axiosConfig, updateVerificationToken } from './lib'

const getNewToken = async (refreshTokenHandler) => {
  try {
    const newToken = await axios.get(refreshTokenHandler, axiosConfig)
    updateVerificationToken(newToken)
    return newToken
  } catch (e) {
    console.warn('Refresh token failed!')
    return false
  }
}

export default getNewToken
